const divTableTitleMat = {
  option1: 'INACTIVATE SELECTED',
  option2: 'PRINT QRCODES',
  option3: 'SEND FOR MAINTENANCE',
  option4: 'RETURN FROM MAINTENANCE',
  option5: 'REACTIVATE SELECTED',
  option6: 'DELETE SELECTED',
  option7: 'CREATE MASS SERVICE',
  option8: 'SERVICES WITH ATTACHMENTS (.ZIP)',
  tooltipBlockQRCode: 'When services can only be done via QRCode in the APP, QRCode printing is only allowed for admins.',
};

export default divTableTitleMat;
